import rawAxios from "./rawAxios";

export const refreshTokenAPI = async (refresh_token) => {
  const response = await rawAxios.get("/admin/users/refresh", {
    headers: {
      Authorization: `Bearer ${refresh_token}`,
    },
  });
  return response.data;
};

export const logoutUserAPI = async (refresh_token) => {
  const response = await rawAxios.get("/admin/users/logout", {
    headers: {
      Authorization: `Bearer ${refresh_token}`,
    },
  });
  return response.data;
};
